import { render, staticRenderFns } from "./EditBarrier.vue?vue&type=template&id=cbe25276&scoped=true"
import script from "./EditBarrier.vue?vue&type=script&lang=js"
export * from "./EditBarrier.vue?vue&type=script&lang=js"
import style0 from "./EditBarrier.vue?vue&type=style&index=0&id=cbe25276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe25276",
  null
  
)

export default component.exports